"use client"
import React, { useEffect, useState } from "react";
 
interface SplitAmountProps {
  amount: string;
}
 
const SplitAmount: React.FC<SplitAmountProps> = ({ amount }) => {
  const [currentLang, setCurrentLng] = useState<string | null>("en"); // Default to "en"
  const [isMounted, setIsMounted] = useState(false);
 

  useEffect(() => {
    setIsMounted(true);
  }, []);

  const parseCurrency = () => {
    // Remove dollar sign and replace commas with periods for consistent parsing
    let cleanAmount = amount.replace("$", "").replace(",", ".");
    // Convert to cents (integer value)
    const cents = Math.round(parseFloat(cleanAmount) * 100);
    return {
      dollars: Math.floor(cents / 100),
      cents: cents % 100
    };
  };
 
  const { dollars, cents } = parseCurrency();
  // Format cents to always show two digits
  const formattedCent = cents < 10 ? `0${cents}` : cents;
 
  // Render the currency formatted correctly based on the locale and amount
  const renderCurrency = () => {
    // For English locale (or default)
    if (currentLang === "en") {
      // For amounts greater than or equal to $1.00
      if (dollars > 0) {
        return (
          <>
            <span className="before">$</span>
            <span className="data">{dollars}</span>
            <span className="after">{amount.includes(",") ? "," : "."}{formattedCent}</span>
          </>
        );
      } else {
        // For amounts less than $1.00 (show as cents)
        return (
          <>
            <span className="before"></span>
            <span className="data">{cents}</span>
            <span className="after">¢</span>
          </>
        );
      }
    } else {
      // For non-English locales
      if (dollars > 0) {
        return (
          <>
            <span className="data">{dollars}</span>
            <span className="after">{amount.includes(",") ? "," : "."}{formattedCent}</span>
            <span className="before">$</span>
          </>
        );
      } else {
        // For amounts less than $1.00 (show as cents)
        return (
          <>
            <span className="before"></span>
            <span className="data">{cents}</span>
            <span className="after">¢</span>
          </>
        );
      }
    }
  };
 
  // If the component hasn't mounted yet, return null or a fallback
  if (!isMounted) {
    return null;
  }
 
  return renderCurrency();
};
 
export default SplitAmount;